"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("../../utilities/classNames"));

var _reactRehydrate = require("@tr-digital/react-rehydrate");

var _Alert = _interopRequireDefault(require("../../elements/Alert"));

var _AlertTypes = require("../../elements/Alert/AlertTypes");

var _AjaxContentTypes = require("./AjaxContentTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AjaxContent = /*#__PURE__*/function (_React$Component) {
  _inherits(AjaxContent, _React$Component);

  var _super = _createSuper(AjaxContent);

  function AjaxContent() {
    var _this;

    _classCallCheck(this, AjaxContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentLocation: null,
      loadingState: _AjaxContentTypes.LoadingState.UNLOADED,
      retrievedChildren: null
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", (0, _classNames["default"])(AjaxContent.displayName));

    _defineProperty(_assertThisInitialized(_this), "isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "fetchContent", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(location) {
        var fetchResponse;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(location, {
                  credentials: "same-origin"
                });

              case 2:
                fetchResponse = _context.sent;

                if (fetchResponse.ok) {
                  _context.next = 5;
                  break;
                }

                throw new Error("Fetch failed for location: ".concat(location));

              case 5:
                return _context.abrupt("return", fetchResponse.text());

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "loadContent", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var location, isNotLoading, content;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              location = _this.props.location;
              isNotLoading = _this.state.loadingState !== _AjaxContentTypes.LoadingState.LOADING;

              if (!(isNotLoading || !location || !_this.isMounted)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              _context2.prev = 4;
              _context2.next = 7;
              return _this.fetchContent(location);

            case 7:
              content = _context2.sent;

              _this.renderAjaxChildren(content);

              _context2.next = 14;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](4);

              _this.handleError(_AjaxContentTypes.AjaxContentErrors.FETCH_ERROR, _context2.t0);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 11]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderAjaxChildren", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(content) {
        var _this$props, location, reactFromMarkupOptions, reactFromMarkupRehydrators, domNode, retrievedChildren;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = _this.props, location = _this$props.location, reactFromMarkupOptions = _this$props.reactFromMarkupOptions, reactFromMarkupRehydrators = _this$props.reactFromMarkupRehydrators;

                if (_this.isMounted) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;
                domNode = document.createElement("div");
                domNode.innerHTML = content;
                _context3.next = 8;
                return (0, _reactRehydrate.rehydrateChildren)(domNode, reactFromMarkupRehydrators, reactFromMarkupOptions);

              case 8:
                retrievedChildren = _context3.sent;

                _this.setState({
                  retrievedChildren: retrievedChildren,
                  currentLocation: location,
                  loadingState: _AjaxContentTypes.LoadingState.LOADED
                }, _this.handleOnChange);

                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](3);

                _this.handleError(_AjaxContentTypes.AjaxContentErrors.REHYDRATE_ERROR, _context3.t0);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 12]]);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function () {
      if (_this.props.onChange) {
        _this.props.onChange(_this.state.loadingState);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleError", function (message, e) {
      // eslint-disable-next-line
      console.error(message, e);

      _this.setState({
        retrievedChildren: null,
        currentLocation: _this.props.location,
        loadingState: _AjaxContentTypes.LoadingState.FAILED
      }, _this.handleOnChange);
    });

    return _this;
  }

  _createClass(AjaxContent, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                /*
                https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
                TODO: rework this component to rely on promise cancellation
                */
                this.isMounted = true;
                _context4.next = 3;
                return this.loadContent();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.loadContent();

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidUpdate() {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // see componentWillMount for info
      this.isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loadingState = _this$state.loadingState,
          retrievedChildren = _this$state.retrievedChildren;
      var _this$props2 = this.props,
          children = _this$props2.children,
          failedContent = _this$props2.failedContent,
          loadingLabel = _this$props2.loadingLabel,
          minHeight = _this$props2.minHeight;
      var showContent = loadingState !== _AjaxContentTypes.LoadingState.FAILED;
      var showLoader = loadingState === _AjaxContentTypes.LoadingState.LOADING;
      var contentClassName = this.getClassName({
        descendantName: "content"
      });
      var baseFontSize = 16;
      /*  eslint no-warning-comments: 0*/

      /*
      eslint-disable
      TODO: make showLoader component
      TODO: make showContent component
      TODO: use css classes instead of style
      eslint-enable
      */

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName(),
        style: minHeight ? {
          minHeight: "".concat(minHeight / baseFontSize, "rem")
        } : {}
      }, showLoader && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "loader"
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "loaderLabel",
          utilities: "hiddenVisually"
        })
      }, loadingLabel)), showContent && retrievedChildren && /*#__PURE__*/_react["default"].createElement("div", {
        className: contentClassName
      }, retrievedChildren), showContent && !retrievedChildren && /*#__PURE__*/_react["default"].createElement("div", {
        className: contentClassName
      }, children), failedContent && loadingState === _AjaxContentTypes.LoadingState.FAILED && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassName({
          descendantName: "failed"
        })
      }, /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
        alertState: _AlertTypes.AlertState.FAILURE
      }, failedContent)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      // if we have no content to load, we are done
      if (!nextProps.location && state.retrievedChildren) {
        return {
          currentLocation: null,
          loadingState: _AjaxContentTypes.LoadingState.LOADED,
          retrievedChildren: null
        };
      } // if location changes, kick off loading


      if (nextProps.location !== state.currentLocation) {
        return {
          loadingState: _AjaxContentTypes.LoadingState.LOADING
        };
      }

      return state;
    }
  }]);

  return AjaxContent;
}(_react["default"].Component);

_defineProperty(AjaxContent, "displayName", "AjaxContent");

_defineProperty(AjaxContent, "defaultProps", {
  location: "",
  failedContent: "Failed to retrieve content",
  loadingLabel: "Loading",
  reactFromMarkupRehydrators: {},
  reactFromMarkupOptions: {
    extra: {}
  }
});

var _default = AjaxContent;
exports["default"] = _default;